var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYtWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.489,
    height: 14.343,
    viewBox: "0 0 20.489 14.343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4038",
    "data-name": "Path 4038",
    d: "M486.64,159.323a4.46,4.46,0,0,0-4.46-4.46H470.611a4.46,4.46,0,0,0-4.46,4.46v5.422a4.46,4.46,0,0,0,4.46,4.46h11.569a4.46,4.46,0,0,0,4.46-4.46Zm-7.3,2.984-4.614,2.53c-.2.109-.381-.036-.381-.265v-5.194c0-.231.186-.375.387-.262l4.646,2.664A.3.3,0,0,1,479.341,162.307Z",
    transform: "translate(-466.151 -154.863)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtWhite);
export default __webpack_public_path__ + "static/media/yt-white.c0490196bcab31804eb5f410bd7b7a4d.svg";
export { ForwardRef as ReactComponent };